import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { addAlphaToHex } from '../../../models/utils/colorUtils';
import { illusionYellow, shortNoticeAmber } from '../../styles/colors';

const { colors, spacing, typography } = THEME;

/**
 * A day inside the advisory notice window: still selectable, but choosing it means writing a reason
 * for the reviewer. The underline is the cue that matters and never fades — it says "this costs you
 * something", which is equally true across the window. The fill only says how much notice is lost,
 * so it lightens as the day moves away from today and toward the date the firm actually asked for.
 */
const shortNoticeDay = {
	borderBottom: `2px solid ${shortNoticeAmber}`,
	// Matches the day button's own radius so a tinted day keeps the shape of every other cell.
	borderRadius: 6,
};

export const styleSheet = StyleSheet.create({
	/**
	 * Today falls inside the unavailable range whenever a minimum is set, so the default grey fill
	 * lands under the disabled fade and reads as nothing. An outline survives it.
	 */
	todayOutlined: {
		backgroundColor: 'transparent',
		border: `1px solid ${colors.primary.main}`,
		borderRadius: 6,
		color: colors.primary.main,
		fontWeight: typography.fontWeights.bold,
	},

	shortNoticeStrong: {
		...shortNoticeDay,
		backgroundColor: illusionYellow,
	},
	shortNoticeMid: {
		...shortNoticeDay,
		backgroundColor: addAlphaToHex(illusionYellow, 0.5),
	},
	shortNoticeSoft: {
		...shortNoticeDay,
		backgroundColor: addAlphaToHex(illusionYellow, 0.2),
	},

	footer: {
		borderTop: THEME.common.border,
		color: colors.text.light,
		display: 'block',
		fontSize: typography.fontSizes.xs,
		marginTop: spacing.sm,
		paddingTop: spacing.sm,
		textAlign: 'center',
	},
});
